import { Heading } from "../../../../../components/elements";
import styles from "./station-content-section.module.less";

export type TStationContentSectionProps = {
  title?: string;
  text?: string;
  children: React.ReactNode;
  isStationPage?: boolean;
};

export const StationContentSection = ({ title, text, isStationPage, children }: TStationContentSectionProps) => {
  return (
    <div className={styles.contentSection}>
      <Heading visualType={"h4"} semanticType={isStationPage ? "h2" : "h4"} className={styles.title}>
        {title}
      </Heading>
      {text && <p className={styles.text}>{text}</p>}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default StationContentSection;
